import React, { memo } from "react";
import { Input } from "antd";

const CommunitySearch = () => {
	return <Input placeholder="Search communities" />;
};

export default memo(CommunitySearch);
